import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireFunctions } from '@angular/fire/functions';
import * as firebase from 'firebase'; //Timestamp (firebase.default.database.ServerValue.TIMESTAMP)
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';


import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Boleto, NovoBoleto } from '../interfaces/sicoob/boleto';
import { boletoSimplificado, RespostaSicoob } from '../interfaces/sicoob/respostaSicoob';
import { UsuarioService } from './usuario.service';
import { PedidoConsultaElement } from '../interfaces/pedido.consulta';
import { gerarMapBoleto } from '../../environments/sicoob';
import funcoesGerais from '../funcoes/funcoesGerais';
import { StatusGerarBoleto } from '../interfaces/sicoob/erroGerarBoleto';
import { PDFDocument } from 'pdf-lib';
import { ConsultaBoleto, ConsultaBoletoDemanda } from '../interfaces/consultaBoleto';
import { BoletoBaixa } from '../interfaces/sicoob/boletoBaixa';
import { TokenSicoob } from '../interfaces/sicoob/token';
import { KJUR } from 'jsrsasign';
import { TELEFONE } from '../interfaces/api-sicoob';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${gerarToken()}`
  })
};

@Injectable()
export class SicoobService {
  uidConfig = environment.idCliente;
  baseURL = environment.apiBoletoUrl;
  certificado: Observable<string | null>;
  $subscribeBoleto: any;

  constructor(
    private db: AngularFireDatabase,
    private fns: AngularFireFunctions,
    private router: Router,
    private toastr: ToastrService,
    private httpClient: HttpClient,
    private usuarioService: UsuarioService
  ) { }

  async gerarBoletoPedido(pedido: PedidoConsultaElement, dataVencimento: Date | null, parcela: number, tokenSicoob: string): Promise<StatusGerarBoleto> {
    try {
      return await new Promise(resolve => {
        this.usuarioService.getClienteByID(pedido.IDUsuario).pipe(take(1)).subscribe((dadosCliente: any) => {
          if (dadosCliente.Nome) {
            // Data de vencimento alterada contando a partir do dia da geração do boleto - REMOVIDO new Date(pedido.Timestamp)
            const auxDataVencimento = dataVencimento ? dataVencimento : funcoesGerais.adicionarDiasDataVencimento(new Date(), pedido.NumeroParcelas === 2 ? (parcela === 1 ? 10 : 15) : pedido.PrazoBoleto);
            const mapGerarBoleto: Array<NovoBoleto> = [gerarMapBoleto(pedido.Total, auxDataVencimento, dadosCliente)];
            console.log(mapGerarBoleto)
            let auxBase64 = '';

            console.log(mapGerarBoleto)
            console.log(JSON.stringify(mapGerarBoleto))
            this.setBoletoSicoob(mapGerarBoleto, tokenSicoob).subscribe(
              (resp: any) => {
                resp = resp.data as boletoSimplificado;
                console.log(resp);
                if (resp) {
                  const auxResp: boletoSimplificado = resp[0];
                  auxBase64 = auxResp.pdfBoleto;

                  const mapBoleto = {
                    CodigoBarras: auxResp.codigoBarras,
                    DataEmissao: new Date(),
                    TimestampEmissao: firebase.default.database.ServerValue.TIMESTAMP,
                    DataVencimento: mapGerarBoleto[0].dataVencimento,
                    TimestampVencimento: new Date(mapGerarBoleto[0].dataVencimento).getTime(),
                    PDFbase64: auxResp.pdfBoleto,
                    Valor: mapGerarBoleto[0].valor,
                    SituacaoBoleto: 'Em Aberto',
                    Status: 'Pendente',
                    Pedido: Number(pedido.ID),
                    NumeroContrato: 339156,
                    NossoNumero: auxResp.nossoNumero,
                    SeuNumero: auxResp.seuNumero,
                    Observacao: pedido.ObservacaoBoleto ? pedido.ObservacaoBoleto : '',
                    IDVendedor: pedido.IDVendedor
                  };

                  var key = this.db.createPushId();

                  let mapBoletoPedido;

                  if (parcela === 1)
                    mapBoletoPedido = {
                      PDFbase64: auxResp.pdfBoleto,
                      SituacaoBoleto: 'Em Aberto',
                      IDBoleto: key,
                      ObservacaoBoleto: pedido.ObservacaoBoleto ? pedido.ObservacaoBoleto : '',
                      ValorBoleto: mapGerarBoleto[0].valor,
                      TimestampVencimento: new Date(mapGerarBoleto[0].dataVencimento).getTime()
                    };
                  else
                    mapBoletoPedido = {
                      PDFbase64Parcela2: auxResp.pdfBoleto,
                      SituacaoBoleto: 'Em Aberto',
                      IDBoleto2: key,
                      ObservacaoBoleto2: pedido.ObservacaoBoleto2 ? pedido.ObservacaoBoleto2 : '',
                      ValorBoleto2: mapGerarBoleto[0].valor,
                      TimestampVencimento2: new Date(mapGerarBoleto[0].dataVencimento).getTime()
                    };
                  this.usuarioService.criarBoleto(mapBoleto, key).then(() => {
                    this.usuarioService.updateBoletoPedido(Number(pedido.ID), mapBoletoPedido).then(resp => {

                      resolve({ Pedido: pedido.ID, Erro: '', PDFbase64: mapBoletoPedido.PDFbase64, Status: true });

                    }).catch((error) => {
                      console.log(error);
                      console.log('retornando 002')
                      resolve({ Pedido: pedido.ID, Erro: `Erro ao salvar boleto no pedido. ${error}`, PDFbase64: '', Status: false });
                    });
                  }).catch((error) => {
                    console.log(error);
                    console.log('retornando 001')
                    resolve({ Pedido: pedido.ID, Erro: `Erro ao criar boleto (TABELA). ${error}`, PDFbase64: '', Status: false });
                  });

                } else {
                  resolve({
                    Pedido: pedido.ID,
                    Erro: resp.mensagem,
                    PDFbase64: '',
                    Status: false
                  })
                }
              },
              (error: any) => {
                console.log(error);
                resolve({ Pedido: pedido.ID, Erro: 'Houve um erro ao gerar o boleto', PDFbase64: auxBase64, Status: false });
              }
            ).add(() => {
              resolve({ Pedido: pedido.ID, Erro: '', PDFbase64: auxBase64, Status: true });
            });
          } else {
            console.log('resolveu com falha dados cliente')
            resolve({ Pedido: pedido.ID, Erro: 'Processamento não realizado, dados do cliente não localizados.', PDFbase64: '', Status: false });
          }
          // return { Pedido: pedido.ID, Erro: 'Processamento não realizado, dados do cliente não localizados.' };
        });
      });
    } catch (error) {
      console.log(error);
      return { Pedido: pedido.ID, Erro: 'Processamento não realizado (LOCAL1)', PDFbase64: '', Status: false };
    }
  }

  erroGerarBoleto(error: any, pedido: PedidoConsultaElement) {
    this.usuarioService.setLog("Erro ao gerar boleto para o pedido: " + pedido.ID + '. Erro: ' + error, null, this.uidConfig);
    this.toastr.error(`Erro ao gerar boleto. Erro: ${error}`, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    setTimeout(() => {
      this.router.navigate(["/pages/consultar-pedidos"]);
    }, 100);
  }

  base64ToArrayBuffer(base64: string): ArrayBufferLike {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    //@ts-ignore
    return bytes;
  }

  async imprimirBoletos(pdfsBase64: string[], nomeArquivo: string | null) {
    const mergedPdf = await PDFDocument.create();
    for (let i = 0; i < pdfsBase64.length; i++) {
      //@ts-ignore
      let auxDoc = await PDFDocument.load(this.base64ToArrayBuffer(pdfsBase64[i]));
      const copiedPages = await mergedPdf.copyPages(auxDoc, auxDoc.getPageIndices());
      copiedPages.forEach((page) => mergedPdf.addPage(page));

    }
    var pdfBytes = await mergedPdf.save();
    //@ts-ignore
    var blob = new Blob([pdfBytes], { type: "application/pdf" });
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `${(nomeArquivo ? nomeArquivo : 'Impressao boletos em demanda')}.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  //#region Chamadas API sicoob
  setBoletoSicoob(boletos: Array<NovoBoleto>, token: string): Observable<any> {
    return this.httpClient.post(`${this.baseURL}`, JSON.stringify({
      boletos,
      token,
      isPrime: false
    }), httpOptions).pipe(take(1));
  }

  getStatusBoletoSicoob(boleto: ConsultaBoleto, token: string): Observable<any> {
    console.log(`${this.baseURL}/${boleto.NumeroContrato}/${boleto.NossoNumero}`)
    return this.httpClient.get(`${this.baseURL}/${boleto.NumeroContrato}/${boleto.NossoNumero}`, httpOptions).pipe(take(1));
  }

  getStatusBoletoDemandaSicoob(boletos: ConsultaBoleto[], token: string): Observable<any> {
    let nossoNumero: number[] = [];

    for (let boleto of boletos)
      nossoNumero.push(Number(boleto.NossoNumero));

    console.log({
      nossoNumero,
      token: token,
      isPrime: false
    })
    console.log(`${this.baseURL}/Sincronizar/${token}`)
    return this.httpClient.post(`${this.baseURL}/Sincronizar`, JSON.stringify({
      nossoNumero,
      token: token,
      isPrime: false
    }), httpOptions).pipe(take(1));
  }

  cancelarBoleto(map: BoletoBaixa[], token: string) {
    return this.httpClient.post(`${this.baseURL}/Cancelar`, JSON.stringify({
      nossoNumero: [map[0].nossoNumero],
      token: token,
      isPrime: false
    }), httpOptions).pipe(take(1));
  }
  //#endregion

  //#region trata e valida o token
  async getToken(): Promise<TokenSicoob> {
    console.log(`${this.baseURL}/token`)
    return await new Promise(resolve => {
      this.httpClient.get(`${this.baseURL}/token?isPrime=false`, httpOptions).pipe(take(1)).subscribe(resp => {
        console.log(resp)
        resolve(resp as TokenSicoob);
      });
    });
  }

  async retornaTokenValidado(tokenSicoob: TokenSicoob): Promise<TokenSicoob> {
    if (!tokenSicoob)
      return await this.getToken();

    return await new Promise(async resolve => {
      if (!this.validarTempoToken(tokenSicoob.dataSolicitacao)) {
        tokenSicoob = await this.getToken();
        tokenSicoob.dataSolicitacao = new Date();
      }

      resolve(tokenSicoob);
    });
  }

  validarTempoToken(dataToken: Date | null): boolean {
    if (dataToken === null)
      return false;

    return !(Math.abs((new Date().getTime() - dataToken.getTime()) / 1000) >= 240); //4 minutos. O token tem duração de 5 minutos
  }
  //#endregion
}

export function gerarToken() {

  const header = { alg: "HS256", typ: "JWT" };

  const payload = { userId: 123, role: 'admin', exp: Math.floor(Date.now() / 1000) + (60 * 60) }; // Expira em 1h

  // Gerando o token
  const token = KJUR.jws.JWS.sign("HS256", header, payload, TELEFONE);
  return token;
}
